import { wait } from '@cloak-app/boilerplate/helpers/function'

# Wait a moment so page re-flows and we scroll to the right place.
export scrollToStep = (stepIndex) -> wait 200, ->
	stepWrapper = document?.querySelector?("#step-wrapper-#{stepIndex}")
	return unless stepWrapper
	stepWrapper.scrollIntoView behavior: 'smooth'
